import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import './education.styles.css'
import EducationLogoUrl from '~/components/layout//assets/education/logo.svg'

export const EducationHeader = () => {
	useEffect(() => {
		const dropdowns = document.querySelectorAll('.dropdown');
		
		dropdowns.forEach(dropdown => {
			dropdown.addEventListener('mouseenter', () => {
				dropdown.classList.add('show');
				const submenu = dropdown.querySelector('.dropdown-menu');
				if (submenu) {
					submenu.classList.add('show'); 
				}
			});

			dropdown.addEventListener('mouseleave', () => {
				dropdown.classList.remove('show');
				const submenu = dropdown.querySelector('.dropdown-menu');
				if (submenu) {
					submenu.classList.remove('show');
				}
			});
		});

		return () => {
			dropdowns.forEach(dropdown => {
				dropdown.removeEventListener('mouseenter', () => {});
				dropdown.removeEventListener('mouseleave', () => {});
			});
		};
	}, []);

	return (
		<>
			<Helmet>
				<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />

				<meta http-equiv="X-UA-Compatible" content="IE=Edge" />
				<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1" />
				<title>Search Jobs | GHR Education</title>
				<meta
					name="description"
					content="Explore education careers and staffing solutions with GHR Healthcare. Connect with the right talent or job opportunity today!"
				/>
				<link rel="preconnect" href="https://static.ghrhealthcare.com/" />
				<link rel="canonical" href="https://www.ghreducation.com/" />
				<link href="/assets/education/scripts/style.css" rel="stylesheet" link="preload" />
				<link rel="shortcut icon" href="https://www.ghreducation.com/favicon.ico" />
				<link rel="apple-touch-icon" sizes="180x180" href="https://static.ghrhealthcare.com/images/favicons/apple-touch-icon.png" />
				<link rel="icon" type="image/png" sizes="32x32" href="https://static.ghrhealthcare.com/images/favicons/favicon-32x32.png" />
				<link rel="icon" type="image/png" sizes="16x16" href="https://static.ghrhealthcare.com/images/favicons/favicon-16x16.png" />
				<link rel="manifest" href="https://static.ghrhealthcare.com/images/favicons/site.webmanifest" />
				<link rel="mask-icon" href="https://static.ghrhealthcare.com/images/favicons/safari-pinned-tab.svg" color="#009dd6" />
				<meta name="msapplication-TileColor" content="#ff0000" />
				<meta name="msapplication-config" content="https://static.ghrhealthcare.com/images/favicons/browserconfig.xml" />
				<meta name="theme-color" content="#ffffff" />
				<meta property="og:url" content="https://www.ghreducation.com/index" />
				<meta property="og:title" content="Home | GHR Education" />
				<meta
					property="og:description"
					content="Explore education careers and staffing solutions with GHR Healthcare. Connect with the right talent or job opportunity today!"
				/>
				<script async="" src="/assets/education/scripts/clarity.js"></script>
				<script src="/assets/education/scripts/49047433.js" type="text/javascript" id="hs-analytics"></script>
				<script
					src="/assets/education/scripts/banner.js"
					type="text/javascript"
					id="cookieBanner-49047433"
					data-cookieconsent="ignore"
					data-hs-ignore="true"
					data-loader="hs-scriptloader"
					data-hsjs-portal="49047433"
					data-hsjs-env="prod"
					data-hsjs-hublet="na1"
				></script>
				<script
					src="/assets/education/scripts/collectedforms.js"
					type="text/javascript"
					id="CollectedForms-49047433"
					crossorigin="anonymous"
					data-leadin-portal-id="49047433"
					data-leadin-env="prod"
					data-loader="hs-scriptloader"
					data-hsjs-portal="49047433"
					data-hsjs-env="prod"
					data-hsjs-hublet="na1"
				></script>
				<script async="" src="/assets/education/scripts/oktrk.js"></script>
				<script async="" src="/assets/education/scripts/mvmrui0cqx"></script>
				<script src="/assets/education/scripts/813742746898208" async=""></script>
				<script async="" src="/assets/education/scripts/fbevents.js"></script>
				<script type="text/javascript" async="" src="/assets/education/scripts/js"></script>
				<script type="text/javascript" async="" src="/assets/education/scripts/hf.js"></script>
				{/* <script async="" src="/assets/education/scripts/gtm.js"></script> */}
				{/* <script src="/assets/education/scripts/widget.js" data-account="JOZViIV1ki"></script> */}

				<script data-cfasync="false" data-pagespeed-no-defer="">
					{`var gtm4wp_datalayer_name = 'dataLayer'
			var dataLayer = dataLayer || []`}
				</script>

				<script type="text/javascript">
					{`window.hfAccountId = '9dd8e1aa-a00b-4c90-a693-343da79aff05'
			window.hfDomain = 'https://api.herefish.com'
			;(function () {
				var hf = document.createElement('script')
				hf.type = 'text/javascript'
				hf.async = true
				hf.src = window.hfDomain + '/scripts/hf.js'
				var s = document.getElementsByTagName('script')[0]
				s.parentNode.insertBefore(hf, s)
			})()`}
				</script>
				<script type="application/ld+json" nonce="">
					{`{
				"@context": "http://schema.org",
				"@type": "WebSite",
				"url": "https://www.ghreducation.com",
				"potentialAction": {
					"@type": "SearchAction",
					"target": "https://www.ghreducation.com/search-results?query={search_term_string}",
					"query-input": "required name=search_term_string"
				}
			}`}
				</script>
				<script type="application/javascript" src="/assets/education/scripts/ping"></script>
				{/* <link href="/assets/education/scripts/widget_base.css" type="text/css" rel="stylesheet" /> */}
			</Helmet>


			{/* <div className="uw-s10-bottom-ruler-guide"></div>
			<div className="uw-s10-right-ruler-guide"></div>
			<div className="uw-s10-left-ruler-guide"></div>
			<div className="uw-s10-reading-guide">
				<div className="uw-s10-reading-guide__arrow"></div>
			</div>
			<div className="uw-s12-tooltip" aria-hidden="true"></div>
			<div id="search-container" className="search-container d-none d-lg-block">
				<div className="container-xxl">
					<div className="row justify-content-between">
						<div className="col-12 rel">
							<form className="search-form-top" method="get" action="https://www.ghreducation.com/search-results">
								<div className="d-flex justify-content-center">
									<div className="top-search-input">
										<input type="text" id="search-query" className="search-query form-control" name="query" title="Search Input" placeholder="Search" />
									</div>
									<button type="submit" className="btn btn-srch">
										Go
									</button>
								</div>
							</form>
							<button className="btn-link close-search closeit">
								<span className="icon-close-circle"></span>
							</button>
						</div>
					</div>
				</div>
			</div> */}
			<header className="fixed-top home scrolled">
				<div className="branding-top home scrolled">
					<div className="container-xxl">
						<div className="row mt-spec">
							<div className="col-6">
								<div className="logo-container">
									<a href="https://www.ghreducation.com/">
                                        <img src={EducationLogoUrl} alt="GHR Education" width="144px" style={{paddingTop: '7px'}} />
									</a>
								</div>
							</div>
							<div className="col-6 text-end pt-lg-2 mt-1">
								<a href="https://www.ghrhealthcare.com/" className="btn btn-top me-2 d-none d-lg-inline-block">
									GHR Healthcare
								</a>
								<a href="https://www.ghreducation.com/quick-apply" className="btn btn-top me-2 d-none d-lg-inline-block">
									Quick Apply
								</a>
								<a href="https://www.ghreducation.com/ghrlive" className="btn btn-top d-none d-lg-inline-block">
									GHR Live!
								</a>
								<button
									className="navbar-toggler collapsed x d-lg-none"
									type="button"
									data-bs-toggle="offcanvas"
									data-bs-target="#mobile-nav"
									aria-controls="mobile-nav"
									aria-expanded="false"
									aria-label="Toggle navigation"
								>
									<span className="bar"></span>
									<span className="bar"></span>
									<span className="bar"></span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div className="top-nav d-none d-lg-block home scrolled">
					<div className="container-xxl g-0">
						<div className="row g-0">
							<nav className="navbar navbar-expand-lg justify-content-between ml-adj">
								<ul className="first-level nav justify-content-between">
									<li className="dropdown">
										<a href="https://www.ghreducation.com/job-opportunities" className="nav-one">
											Job Seekers
										</a>
										<ul className="dropdown-menu second-level">
											<li>
												<a href="https://www.ghreducation.com/job-opportunities/index">Job Opportunities</a>
											</li>
											<li>
												<a href="https://www.ghreducation.com/job-opportunities/what-to-expect">What to Expect</a>
											</li>
											<li>
												<a href="https://www.ghreducation.com/job-opportunities/pay-benefits">Pay &amp; Benefits</a>
											</li>
											<li>
												<a href="https://www.ghreducation.com/ghrlive">GHR Live! App</a>
											</li>
										</ul>
									</li>
									<li className="dropdown">
										<a href="https://www.ghreducation.com/staffing-solutions" className="nav-one">
											Employers
										</a>
										<ul className="dropdown-menu second-level">
											<li>
												<a href="https://www.ghreducation.com/staffing-solutions/index">Staffing Solutions</a>
											</li>
											<li>
												<a href="https://www.ghreducation.com/staffing-solutions/managed-services">Managed Services</a>
											</li>
										</ul>
									</li>
									<li className="dropdown">
										<a href="https://www.ghreducation.com/blog" className="nav-one">
											Resources
										</a>
										<ul className="dropdown-menu second-level">
											<li>
												<a href="https://www.ghreducation.com/blog/index">Stories &amp; Resources</a>
											</li>
										</ul>
									</li>
									<li className="dropdown">
										<a href="https://www.ghreducation.com/about-us" className="nav-one">
											Why GHR
										</a>
										<ul className="dropdown-menu second-level">
											<li>
												<a href="https://www.ghreducation.com/about-us/index">About Us</a>
											</li>
											<li>
												<a href="https://www.ghreducation.com/about-us/corporate-careers">Corporate Careers</a>
											</li>
										</ul>
									</li>
									<li className="dropdown">
										<a href="https://www.ghreducation.com/contact" className="nav-one">
											Contact Us
										</a>
										<ul className="dropdown-menu second-level">
											<li>
												<a href="https://www.ghreducation.com/contact/index">Contact Us</a>
											</li>
										</ul>
									</li>
									<li>
										<a href="https://www.ghreducation.com/" className="open-search">
											<span className="icon-search"></span>
										</a>
									</li>
								</ul>
							</nav>
						</div>
					</div>
				</div>
			</header>
			<div id="mobile-nav" className="offcanvas offcanvas-end d-print-none">
				<div className="mbl-cta">
					<a href="https://www.ghrhealthcare.com/" className="btn btn-top mb-3 d-block d-lg-none">
						GHR Healthcare
					</a>
					<a href="https://www.ghreducation.com/quick-apply" className="btn btn-top mb-3 d-block d-lg-none">
						Quick Apply
					</a>
					<a href="https://www.ghreducation.com/ghrlive" className="btn btn-top d-block d-lg-none">
						GHR Live!
					</a>
				</div>
				<ul id="mblist" className="mobile-nav first">
					<li>
						<a href="https://www.ghreducation.com/#mn-job-opportunities" className="collapsed" data-bs-toggle="collapse">
							Job Seekers
						</a>
						<ul id="mn-job-opportunities" className="mbl-second collapse" data-bs-parent="#mblist">
							<li>
								<a href="https://www.ghreducation.com/job-opportunities/index">Job Opportunities</a>
							</li>
							<li>
								<a href="https://www.ghreducation.com/job-opportunities/what-to-expect">What to Expect</a>
							</li>
							<li>
								<a href="https://www.ghreducation.com/job-opportunities/pay-benefits">Pay &amp; Benefits</a>
							</li>
						</ul>
					</li>
					<li>
						<a href="https://www.ghreducation.com/#mn-staffing-solutions" className="collapsed" data-bs-toggle="collapse">
							Employers
						</a>
						<ul id="mn-staffing-solutions" className="mbl-second collapse" data-bs-parent="#mblist">
							<li>
								<a href="https://www.ghreducation.com/staffing-solutions/index">Staffing Solutions</a>
							</li>
							<li>
								<a href="https://www.ghreducation.com/staffing-solutions/managed-services">Managed Services</a>
							</li>
						</ul>
					</li>
					<li>
						<a href="https://www.ghreducation.com/#mn-blog" className="collapsed" data-bs-toggle="collapse">
							Resources
						</a>
						<ul id="mn-blog" className="mbl-second collapse" data-bs-parent="#mblist">
							<li>
								<a href="https://www.ghreducation.com/blog/index">Stories &amp; Resources</a>
							</li>
						</ul>
					</li>
					<li>
						<a href="https://www.ghreducation.com/#mn-about-us" className="collapsed" data-bs-toggle="collapse">
							Why GHR
						</a>
						<ul id="mn-about-us" className="mbl-second collapse" data-bs-parent="#mblist">
							<li>
								<a href="https://www.ghreducation.com/about-us/index">About Us</a>
							</li>
							<li>
								<a href="https://www.ghreducation.com/about-us/corporate-careers">Corporate Careers</a>
							</li>
						</ul>
					</li>
					<li>
						<a href="https://www.ghreducation.com/#mn-contact" className="collapsed" data-bs-toggle="collapse">
							Contact Us
						</a>
						<ul id="mn-contact" className="mbl-second collapse" data-bs-parent="#mblist">
							<li>
								<a href="https://www.ghreducation.com/contact/index">Contact Us</a>
							</li>
						</ul>
					</li>
				</ul>
			</div>

		</>
	)
}
